import { debugLog as log } from 'shared-services/logger-service';

import AjaxService from '../services/ajax-service';
import { convertToFormData } from '../utils/helpers';

export const createCode = (email, campaign) => {
    return AjaxService({
        method: 'post',
        url: 'verify',
        data: { email, campaign }
    }).then(response => {
        log(response);
        return response.data;
    });
}

export const verifyCode = (code, email) => {
    return AjaxService({
        method: 'post',
        url: 'verify/check',
        data: { code, email }
    }).then(response => response.data.data);
}

export const resetPassword = (password, token, email) => {
    return AjaxService({
        method: 'post',
        url: `auth/password/reset`,
        data: { password, token, email }
    }).then(response => response.data);
}

export const signup = ({ email, code, name, password, avatar }) => {
    return AjaxService({
        method: 'post',
        url: `auth/signup`,
        data: convertToFormData({
            email,
            code,
            name,
            password,
            avatar
        })
    }).then(response => response.data);
}

export const getTeamTokens = () => {
    return AjaxService({
        method: 'get',
        url: `auth/tokens`
    }, true).then(response => response.data);
}

export const forgottenPassword = data => {
    return AjaxService({
        method: 'post',
        url: `auth/password/forgot`,
        data
    }).then(response => response.data);
}

export const login = ({ email, password }) => {
    return AjaxService({
        method: 'post',
        url: `auth/signin`,
        data: {
            email,
            password
        }
    }).then(response => {
        if (response.data.error) {
            throw response.data.error.details.message;
        }

        return response.data;
    })
}

export const acceptInvite = ({ name, email, password, token, provider, socialData, theme }) => {
    return AjaxService({
        method: 'post',
        url: `auth/invite/accept`,
        data: {
            name,
            email: email ? email : undefined,
            password,
            token,
            provider,
            socialData,
            theme
        }
    }).then(response => response.data);
}

export const checkEmail = email => {
    return AjaxService({
        method: 'post',
        url: `auth/check_email`,
        data: { email }
    }).then(response => {
        if (response.data.error) {
            throw response.data.error.details.message;
        }

        if (response.data.used === true) {
            throw new Error('This email is already in use. Please try another email or sign in to your account.');
        }

        return response.data;
    });
}

export const checkInviteToken = token => {
    return AjaxService({
        method: 'post',
        url: `auth/invite/check`,
        data: { token }
    }).then(response => response.data);
}

export const ssoLogin = ({ provider, socialData }) => {
    return AjaxService({
        method: 'post',
        url: `auth/social`,
        data: {
            provider,
            socialData
        }
    }).then(response => response.data.data);
}

export const ssoSignup = ({ provider, socialData, team_name, team_url, code, plan }) => {
    return AjaxService({
        method: 'post',
        url: `auth/social_signup`,
        data: {
            provider,
            socialData,
            team_name,
            team_url,
            code,
            plan
        }
    }).then(response => response.data.data);
}
